import { Credential, DataBaseTable } from '@nexla/@types';
import usePaging from 'new/state/paging/repository/usePaging';
import useFlowsSetup from 'new/components/flows/controller/useFlowsSetup';
import FlowTypes from 'new/components/flows/types/flowTypes';
import { FORM_TYPE_CREATE_DIRECT_FLOW } from 'js/constants/formTypes';
import useFlowType from './useFlowType';

type FlowTypesKeys = keyof typeof FlowTypes;
type FlowTypesKeysValues = (typeof FlowTypes)[FlowTypesKeys];

type UseDirectFlow = {
  flowType?: FlowTypesKeysValues;
  connectionCategory?: string; // e.g database
  connectionType: 'SOURCE' | 'SINK';
  credentialId?: number;
  effectiveConnectionType?: string;
  selectedConnection?: string; // e.g mysql
  selectedCredential?: Credential;
  selectedBucket?: any;
  sink?: any;
  source?: any;
  nexset?: any;
  sinkConfig?: Record<string, string>;
  sourceConfig?: Record<string, string>;
  isEditMode: boolean;
  sourceConfigFields: Array<any>;
  table: DataBaseTable;
  isNewTable?: boolean;
  destinationDraftValue: boolean;
  showEditedNexsetView: boolean;
  onStartForm(): void;
  onTableSelected(table: any, db: any): void;
  updateFormData(data: any, resetValidationStatus?: boolean): void;
  onSelectConnection(connection: string): void;
  toggleDestinationDraft(value?: boolean): void;
  onShowEditedNexsetView(value: boolean): void;
};

const FORM = FORM_TYPE_CREATE_DIRECT_FLOW;

export function useDirectFlow(): UseDirectFlow {
  const paging = usePaging();
  const flowType = useFlowType();
  const {
    data,
    end: onEndForm,
    start: onStartForm,
    updateFormData,
    resetFormData,
    onSelectConnection,
    onTableSelected,
    effectiveConnectionType,
  } = useFlowsSetup(FORM, flowType);

  const { selectedConnection } = data || {};

  const connectionCategory = paging.getConnectionCategoryByConnectorType(selectedConnection);

  const isEditMode =
    !!(data.connectionType === 'SOURCE' && data.source?.id) ||
    !!(data.connectionType === 'SINK' && data.sink?.id);

  const toggleDestinationDraft = (destinationDraftState = false) =>
    updateFormData({ destinationDraftValue: destinationDraftState });

  return {
    ...data,
    isEditMode,
    connectionCategory,
    effectiveConnectionType,
    showEditedNexsetView: data.showEditedNexsetView,
    destinationDraftValue: data.destinationDraftValue,
    onEndForm,
    onStartForm,
    resetFormData,
    updateFormData,
    onTableSelected,
    toggleDestinationDraft,
    getAuthFields: paging.getAuthFields,
    getMetaInfoById: paging.getMetaInfoById,
    getSourceConfigFields: paging.getSourceConfigFields,
    onSelectConnection: onSelectConnection(flowType),
  } as UseDirectFlow;
}
